
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93guPQoOT5G6Meta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93guKa52lRDXMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/blogg/[...slug].vue?macro=true";
import { default as index4EVhxOJtCRMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/blogg/index.vue?macro=true";
import { default as indexH1nDLBFVttMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/checkout/index.vue?macro=true";
import { default as paymentDk1smRUfElMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clientfFGQsEjHbdMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/hillceramic.se/releases/20261105081705Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexAGJaE7VN5DMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/collections/index.vue?macro=true";
import { default as _91slug_93Js8U0u2TpyMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/faq/[slug].vue?macro=true";
import { default as indexkNSVCPWOJOMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as index9JpcM4jSnRMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/index.vue?macro=true";
import { default as index2A588N9i1qMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/login/index.vue?macro=true";
import { default as _91id_938VJndNQ6K7Meta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/qr-pr/[id].vue?macro=true";
import { default as formlL4W2yxJTcMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/review/form.vue?macro=true";
import { default as indexAvCgqfU7m2Meta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_93zM9NykxFHKMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/shop/[...slug].vue?macro=true";
import { default as indexO4HHdjDB6ZMeta } from "/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___sv",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93guPQoOT5G6Meta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___sv",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___sv",
    path: "/blogg",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___sv",
    path: "/checkout",
    meta: indexH1nDLBFVttMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___sv",
    path: "/checkout/payment",
    meta: paymentDk1smRUfElMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___sv",
    path: "/checkout/thank-you",
    meta: index_46clientfFGQsEjHbdMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___sv",
    path: "/kollektioner",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___sv",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___sv",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___sv",
    path: "/",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/index.vue")
  },
  {
    name: "login___sv",
    path: "/login",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___sv",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___sv",
    path: "/review/form",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/review/form.vue")
  },
  {
    name: "review___sv",
    path: "/review",
    meta: indexAvCgqfU7m2Meta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___sv",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___sv",
    path: "/track",
    meta: indexO4HHdjDB6ZMeta || {},
    component: () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/pages/track/index.vue")
  }
]